<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 38px;
        font-weight: bold;
        color: #05523e;
        padding-top: 50px;
      "
    >
      Add Invoice
    </v-card-title>
    <div
      style="
        display: flex;
        justify-content: end;
        width: 100%;
        align-items: center;
      "
    >
      <v-col cols="6">
        <v-row justify="end">
          <v-col cols="3">
            <v-select
              v-model="column"
              label="Category"
              :items="searchSelects"
              item-text="name"
              item-value="value"
              dense
              single-line
              color="#05523E"
              :hide-details="true"
            />
            <v-text-field
              style="margin-top: 30px"
              hide-details="true"
              outlined
              dense
              label="Search Item"
              placeholder="Please input description"
              v-model="searchItemForDescription"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="search"
              :search-input.sync="searchInput"
              :items="searchCompanyList"
              outlined
              dense
              chips
              item-text="CustNum"
              item-value="CustNum"
              small-chips
              label="Search Company"
              @keypress.enter="getCustomers()"
            ></v-autocomplete>
          </v-col>
          <v-btn
            class="action white--text elevation-5"
            color="#05523E"
            style="
              min-width: 100px;
              font-size: 15px;
              font-weight: bold;
              height: 35px;
              margin: 12px;
            "
            @click="showTemplate"
            >Add Template</v-btn
          >
        </v-row>
      </v-col>
    </div>
    <div style="display: flex; justify-content: end; width: 100%">
      <v-col cols="6">
        <v-row justify="end">
          <v-col cols="3"> </v-col>
          <v-col cols="6"> </v-col>
        </v-row>
      </v-col>
    </div>
    <div style="margin: auto 20px">
      <Loading v-if="isSearch" />
      <v-data-table
        :headers="headers"
        :items="
          !searchItemForDescription
            ? template
            : template.filter((item) =>
                searchItem(
                  `${item.ItemName}(${
                    item.ItemName_Extra || item.Vendor_Part_Num || ''
                  })`
                )
              )
        "
        :page.sync="page_No"
        :items-per-page="template.length"
        hide-default-footer
        :loading="loading"
        loading-text="Loading... Please wait"
      >
        <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                            <th v-for="h in headers" v-bind:key="h.text">
                                <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                            </th>
                        </tr>
                    </thead>
                </template> -->
        <template v-slot:item="{ item, index }">
          <tr
            :style="{
              'background-color':
                item.Quantity > item.In_Stock
                  ? 'rgba(250,22,22,0.21)'
                  : 'rgba(250,255,255)',
            }"
          >
            <td>{{ item.LineNum }}</td>
            <td>
              <v-text-field
                @input="
                  setMappingInput(item, index);
                  setGrandTotal();
                  setProfit(item);
                "
                @blur="applyData(item)"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                v-model="item.Quantity"
                style="margin: auto 10px; max-width: 50px; min-width: 50px"
              />
            </td>
            <td>{{ item.In_Stock }}</td>
            <td>{{ item.ItemNum }}</td>
            <td>
              <!-- <span
                :class="{
                  highlight: searchItem(
                    `${item.ItemName}(${
                      item.ItemName_Extra || item.Vendor_Part_Num || ''
                    })`
                  ),
                }"
              >
                {{
                  `${item.ItemName}(${
                    item.ItemName_Extra || item.Vendor_Part_Num || ""
                  })`
                }}
              </span> -->
              <text-highlight
                :caseSensitive="false"
                :queries="searchItemForDescription"
                >{{
                  `${item.ItemName}(${
                    item.ItemName_Extra || item.Vendor_Part_Num || ""
                  })`
                }}</text-highlight
              >
            </td>
            <td>{{ item.Cost }}</td>
            <td>{{ item.ChargedPrice }}</td>
            <td>
              <v-text-field
                @input="
                  setGrandTotal();
                  setProfit(item);
                "
                @blur="applyData(item)"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                v-model="item.Price"
                style="margin: auto 10px; max-width: 70px; min-width: 70px"
              />
            </td>
            <td>{{ item.Total }}</td>
            <td>
              {{
                roundToTwo(
                  item.Price * 1 * item.Quantity - item.Cost * 1 * item.Quantity
                )
              }}
            </td>
            <td>
              {{
                item.Quantity != 0 ? getProfitPer2(item.Price, item.Cost) : 0
              }}
            </td>
            <td>
              <v-btn
                style="font-size: 15px; color: #05523e"
                @click="openPriceModal(item)"
              >
                Latest prices
              </v-btn>
            </td>
            <td>
              <v-btn
                style="font-size: 15px"
                color="rgb(216, 108, 108)"
                @click="removeItem(item, index)"
              >
                <v-icon color="white">mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-divider />
      <div class="total">
        <span>Grand Total: </span>
        <span style="margin-left: 25px"
          >$ {{ roundToTwo(grandTotal * 1) }}
        </span>
        <span style="margin-left: 25px">Grand Profit: </span>
        <span style="margin-left: 25px"
          >$ {{ !isNaN(grandProfit) ? roundToTwo(grandProfit) : 0 }}
        </span>
        <span style="margin-left: 25px">Grand ProfitPer: </span>
        <span style="margin-left: 25px"
          >{{ !isNaN(grandProfitPer) ? roundToTwo(grandProfitPer * 1) : 0 }} %
        </span>
      </div>
    </div>
    <v-card-actions style="padding-right: 50px; justify-content: center">
      <v-btn
        class="action elevation-5"
        color="#ffffff"
        style="
          color: #05523e;
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="$emit('closeAddModal')"
        >Cancle</v-btn
      >
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="createInvoice"
        >Add</v-btn
      >
    </v-card-actions>
    <v-dialog v-model="$store.state.common.latestPriceModalView" width="900">
      <LatestPriceModal :currentDescription="currentDescription" />
    </v-dialog>
    <div v-if="templateModal">
      <v-dialog v-model="templateModal" width="1500">
        <EditInvoiceTemplateModal
          :loading="loading"
          style="min-height: 300px"
          v-bind:custNum="selectCompany"
          v-bind:companyName="$store.state.invoice.invoiceOne.companyName"
          @closeModal="closeModal"
          @addTemplateList="addTemplateList"
        />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import {
  GETLATESTPRICE,
  CHECKITEMANDCRV,
  GETINVENTORYFORTAG,
} from "@/graphql/InvoiceQueries.js";
import { debounce } from "lodash";
import LatestPriceModal from "@/components/modal/LatestPriceModal.vue";
import common from "@/util/common.js";
import { runGqlQuery, runGqlMutation } from "@/graphql/gqlUtil.js";
import { CREATEINVOICE } from "@/graphql/InvoiceMutations.js";
import Demical, { Decimal } from "decimal.js";
import EditInvoiceTemplateModal from "@/components/modal/EditInvoiceTemplateModal.vue";
import Loading from "../Common/Loading.vue";
export default {
  components: {
    LatestPriceModal,
    EditInvoiceTemplateModal,
    Loading,
  },
  data() {
    return {
      currentDescription: "",
      searchItemForDescription: "",
      grandTotal: 0,
      grandProfitPer: 0,
      grandProfit: 0,
      templateModal: false,
      search: "",
      loading: false,
      template: [],
      headers: [
        {
          // sort: (a, b) => a.localeCompare(b),
          text: "#",
          align: "start",
          sortable: true,
        },
        {
          text: "QTY/LB",
          value: "QuantityApply",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Stock",
          value: "In_Stock",
          // sort: (a, b) => a - b,
        },
        {
          text: "ITEM NUMBER",
          value: "ItemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "DESCRIPTON",
          value: "ItemName",
          width: 200,
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "COST ($)",
          value: "Cost",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Charged Price ($)",
          value: "ChargedPrice",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "PRICE ($)",
          value: "PriceApply",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "EXTENDED ($)",
          value: "Total",
          // sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Profit",
          value: "Profit",
          // sort: (a, b) => a.local eCompare(b),
        },
        {
          text: "ProfitPer (%)",
          value: "ProfitPer",
          // sort: (a, b) => a.localeCompare(b),
        },
        { text: "", sortable: false },
      ],
      searchSelects: [
        // { name: "Company Name", value: "Company" },
        { name: "Cust Number", value: "CustNum" },
      ],
      column: "CustNum",
      page_No: 0,
      searchCompanyList: [],
      selectCompany: null,
      searchInput: "",
      isSearch: false,
    };
  },
  watch: {
    search: function (newVal, preVal) {
      console.log(newVal);
      if (newVal) {
        this.selectCompany = newVal;
        this.isSearch = true;
        this.getTemplateOne(newVal);
      } else {
        this.template = [];
        this.grandProfit = 0;
        this.grandProfitPer = 0;
        this.grandTotal = 0;
      }
    },
    template: function (newVal) {
      console.log(newVal);
      if (newVal.length > 0) {
        this.setGrandTotal();
        newVal.map((item) => {
          this.setProfit(item);
        });
      }
    },
  },
  async created() {
    // this.setGrandTotal = debounce(this.setGrandTotal, 400);
    // this.setProfit = debounce(this.setProfit, 400);
    // this.setMappingInput = debounce(this.setMappingInput, 400);
    this.setGrandTotal();
  },
  methods: {
    async setMappingInput(item, index) {
      if (item.MappingLineNum || item.MappedLineNum) {
        const findIndex = this.template.findIndex((item1) =>
          item.MappingLineNum
            ? item1.LineNum === item.MappingLineNum && item1.Type === "CRV"
            : item1.LineNum === item.MappedLineNum && item1.Type === "Item"
        );

        this.template[findIndex].Quantity = item.Quantity;
        // this.template[findIndex].Total = this.roundToTwo(
        //   this.template[findIndex].PricePer * 1 * Number(item.Quantity)
        // );
        this.setProfit(this.template[findIndex]);
      }
    },
    removeItem(item, index) {
      console.log(index);
      this.template = this.template.filter((item2, index2) => {
        return index2 != index;
      });
      if (item.MappedLineNum !== undefined) {
        this.template = this.template.filter((item2, index2) => {
          return index2 !== index - 1;
        });
      }
      if (item.MappingLineNum !== undefined) {
        this.template = this.template.filter((item2, index2) => {
          return index2 !== index;
        });
      }
    },
    closeModal() {
      this.templateModal = false;
    },
    async addTemplateList(selected) {
      console.log(selected);

      let add = [];
      let LineNum = this.template.map((item) => item.LineNum);
      let maxNum = Math.max(...LineNum);
      if (!isFinite(maxNum)) maxNum = 1;
      if (this.template.length > 0) ++maxNum;
      for (let i = 0; i < selected.length; i++) {
        const checkCrv = await runGqlQuery(CHECKITEMANDCRV, {
          ItemNum: `${selected[i].ItemNum}`,
        });
        const Total = this.roundToTwo(
          selected[i].PricePer * 1 * selected[i].Quantity
        );
        if (checkCrv.checkItemAndCRV.ItemType === "NONE") {
          add.push({
            ...selected[i],
            LineNum: maxNum++,
            QuantityApply: selected[i].Quantity,
            PriceApply: selected[i].Price,
            Profit: 0,
            ProfitPer: 0,
            PricePer: selected[i].PricePer,
            Price: selected[i].PricePer,
            Cost: selected[i].CostPer,
            Total: Total,
          });
        } else if (checkCrv.checkItemAndCRV.ItemType === "ITEM") {
          add.push({
            ...selected[i],
            Type: "Item",
            LineNum: maxNum++,
            // LineNum: i + 1,
            MappingLineNum: maxNum,
            QuantityApply: selected[i].Quantity,
            PriceApply: selected[i].Price,
            Profit: 0,
            ProfitPer: 0,
            PricePer: selected[i].PricePer,
            Price: selected[i].PricePer,
            Cost: selected[i].CostPer,
            Total: Total,
          });
          console.log(checkCrv.checkItemAndCRV.TagItemNum[0]);
          const item = await runGqlQuery(GETINVENTORYFORTAG, {
            ItemNum: `${checkCrv.checkItemAndCRV.TagItemNum[0]}`,
            CustNum: `${this.$store.state.invoice.invoiceOne.custNum}`,
          });
          console.log(item);
          const TotalTag = this.roundToTwo(
            item.getInventory.Price * 1 * selected[i].Quantity
          );
          add.push({
            ...item.getInventory,
            ChargedPrice: item.getInventory.ChargedPrice,
            LineNum: maxNum++,
            MappedLineNum: maxNum - 2,
            Type: "CRV",
            QuantityApply: selected[i].Quantity,
            Quantity: selected[i].Quantity,
            PriceApply: item.getInventory.Price,
            Profit: 0,
            ProfitPer: 0,
            PricePer: item.getInventory.Price,
            Price: item.getInventory.Price,
            Cost: item.getInventory.Cost,
            Total: TotalTag,
          });
        }
      }

      this.template.push(...add);
      console.log(this.template);
      this.templateModal = false;
    },
    async showTemplate() {
      console.log(this.selectCompany);
      if (this.selectCompany) {
        await this.$store.dispatch("invoice/getTemplates", {
          CustNum: this.selectCompany,
        });
        this.templateModal = !this.templateModal;
      } else {
        await this.$store.commit("common/snackErrOn", {
          text: "There is no cust number. Please select cust number",
        });
        return;
      }
    },
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    searchItem(item) {
      const target = this.searchItemForDescription
        .toUpperCase()
        .replace(/ /gi, "");
      const trimItem = item.toUpperCase().replace(/ /gi, "");
      if (!target) return false;
      if (trimItem === target) return true;
      return trimItem.includes(target) ? true : false;
    },
    applyData(item) {
      item.QuantityApply = item.Quantity;
      item.PriceApply = item.Price;
    },
    setProfit(item) {
      item.Profit = this.roundToTwo(
        item.PricePer * 1 * item.Quantity - item.CostPer * 1 * item.Quantity
      );
      item.ProfitPer =
        item.Quantity != 0
          ? this.getProfitPer2(item.PricePer, item.CostPer)
          : 0;
      item.Total = this.roundToTwo(item.Price * 1 * item.Quantity);
    },
    setGrandTotal() {
      const arr = [...this.template];
      this.grandTotal = this.roundToTwo(
        arr.reduce((pre, cur, i) => {
          return pre + cur.Price * 1 * cur.Quantity;
        }, 0)
      );
      //   getProfitPer(
      //                   (item.Price * 1 * item.Quantity) /
      //                     (item.Cost * 1 * item.Quantity)
      //                 )
      const grandProfit = this.roundToTwo(
        arr.reduce((pre, cur, i) => {
          return (
            pre +
            this.roundToTwo(
              cur.Price * 1 * cur.Quantity - cur.Cost * 1 * cur.Quantity
            )
          );
          // return pre + cur.Cost * 1 * cur.Quantity;
        }, 0)
      );
      const costTotal = this.roundToTwo(
        arr.reduce((pre, cur, i) => {
          return pre + this.roundToTwo(cur.Cost * 1 * cur.Quantity);
        }, 0)
      );
      console.log(this.grandTotal, costTotal);
      this.grandProfit = grandProfit;
      console.log(this.grandProfit);
      this.grandProfitPer =
        this.getProfitPer((this.grandTotal - costTotal) / costTotal) * 100;
    },
    getProfitPer2(price, cost) {
      return this.round(
        ((Demical((price * 1 - cost * 1) / cost) * 1 * 100) / 1).toFixed(3)
      );
      //this.getProfitPer(
      //);
    },
    round(num) {
      var m = Number((Math.abs(num) * 100).toPrecision(15));
      return (Math.round(m) / 100) * Math.sign(num);
    },

    getProfitPer(num) {
      //   return common.roundToTwo(num);

      Decimal.set({
        rounding: 4,
      });
      return Number.parseFloat(Demical(num));
    },
    async createInvoice() {
      const orderArray = [];
      let j = 1;
      for (let i = 0; i < this.template.length; i++) {
        // prefs.setString(orderList[i]['ItemNum'], orderList[i]['Quantity']);
        if (
          this.template[i]["Quantity"] != 0 &&
          this.template[i]["Quantity"] != ""
        )
          orderArray.push({
            LineNum: j++,
            ItemNum: this.template[i]["ItemNum"],
            Quantity: Number(this.template[i]["Quantity"]),
            PricePer: Number(this.template[i]["Price"]),
          });
      }
      const req = {
        CustNum: this.selectCompany,
        InsertItems: orderArray,
      };
      const filter = orderArray.filter((item) => item.Quantity == 0);
      if (filter.length !== orderArray.length) {
        try {
          const insertResult = await runGqlMutation(CREATEINVOICE, req);
          if (insertResult.createInvoice.ResultCount === 1) {
            this.$store.commit("common/snackOn", {
              text: "Invoice Add Complete!",
            });
          } else {
            this.$store.commit("common/snackErrOn", {
              text: "Please order at least one item",
            });
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        this.$store.commit("common/snackErrOn", {
          text: "Please order at least one item",
        });
      }
    },
    async openPriceModal(item) {
      try {
        const priceResult = await runGqlQuery(GETLATESTPRICE, {
          ItemNum: item.ItemNum,
        });

        this.currentDescription = `${item.ItemName}(${
          item.ItemName_Extra || item.Vendor_Part_Num || ""
        })`;

        if (
          priceResult !== undefined &&
          priceResult.getLatestPrice.length !== 0
        ) {
          await this.$store.commit(
            "invoice/setLatestPrices",
            priceResult.getLatestPrice
          );
        } else {
          await this.$store.commit("common/snackErrOn", {
            text: "There are no recent prices!",
          });
          return;
        }

        await this.$store.commit("common/changeLatestPriceModalView");
      } catch (err) {
        console.error(err);
      }
    },
    async getTemplateOne(custNum) {
      try {
        let template = await this.$store.dispatch(
          "invoice/getTemplatesForAdd",
          {
            CustNum: custNum,
          }
        );

        let add = [];

        let maxNum = 1;

        for (let i = 0; i < template.length; i++) {
          const checkCrv = await runGqlQuery(CHECKITEMANDCRV, {
            ItemNum: `${template[i].ItemNum}`,
          });
          if (checkCrv.checkItemAndCRV.ItemType === "NONE") {
            add.push({
              ...template[i],
              LineNum: maxNum++,
              QuantityApply: template[i].Quantity,
              PriceApply: template[i].Price,
              Total: this.roundToTwo(
                template[i].Price * 1 * template[i].Quantity
              ),
              Profit: this.roundToTwo(
                this.roundToTwo(
                  template[i].PricePer * 1 * template[i].Quantity
                ) -
                  this.roundToTwo(
                    template[i].CostPer * 1 * template[i].Quantity
                  )
              ),
              ProfitPer:
                template[i].Quantity != 0
                  ? this.getProfitPer2(
                      template[i].PricePer,
                      template[i].CostPer
                    )
                  : 0,
            });
          } else if (checkCrv.checkItemAndCRV.ItemType === "ITEM") {
            const item = await runGqlQuery(GETINVENTORYFORTAG, {
              ItemNum: `${checkCrv.checkItemAndCRV.TagItemNum[0]}`,
              CustNum: `${this.$store.state.invoice.invoiceOne.custNum}`,
            });
            add.push({
              ...template[i],
              Type: "Item",
              LineNum: maxNum,
              MappingLineNum: maxNum + 1,
              QuantityApply: template[i].Quantity,
              PriceApply: template[i].Price,
              Total: this.roundToTwo(
                template[i].Price * 1 * template[i].Quantity
              ),
              Profit: this.roundToTwo(
                this.roundToTwo(
                  template[i].PricePer * 1 * template[i].Quantity
                ) -
                  this.roundToTwo(
                    template[i].CostPer * 1 * template[i].Quantity
                  )
              ),
              ProfitPer:
                item.Quantity != 0
                  ? this.getProfitPer2(
                      template[i].PricePer,
                      template[i].CostPer
                    )
                  : 0,
            });
            // currentLine = maxNum + (i + 1);
            add.push({
              ...item.getInventory,
              Type: "CRV",
              // LineNum: maxNum + i,
              // MappedLineNum: currentLine,
              ChargedPrice: item.getInventory.ChargedPrice,
              LineNum: maxNum + 1,
              MappedLineNum: maxNum,
              QuantityApply: template[i].Quantity,
              PriceApply: item.getInventory.Price,
              Total: this.roundToTwo(
                item.getInventory.Price * 1 * template[i].Quantity
              ),
              Profit: this.roundToTwo(
                this.roundToTwo(
                  item.getInventory.Price * 1 * template[i].Quantity
                ) -
                  this.roundToTwo(
                    item.getInventory.Cost * 1 * template[i].Quantity
                  )
              ),
              ProfitPer:
                item.Quantity != 0
                  ? this.getProfitPer2(item.PricePer, item.CostPer)
                  : 0,

              // QuantityApply: template[i].Quantity,
              Quantity: template[i].Quantity,
              // PriceApply: item.getInventory.Price,
              // Profit: 0,
              // ProfitPer: 0,
              PricePer: item.getInventory.Price,
              Price: item.getInventory.Price,
              Cost: item.getInventory.Cost,
            });
            maxNum = maxNum + 2;
          }
        }
        const minusArr = add.filter((item) => {
          return item.LineNum === undefined;
        });

        const addArr = add.filter((item) => item.LineNum !== undefined);
        console.log(minusArr, addArr);
        this.template = [...minusArr, ...addArr];
      } catch (e) {
        console.log(e);
      }
      this.isSearch = false;
    },
    async getCustomers() {
      console.log(this.column);
      if (!this.column) {
        return this.$store.commit("common/snackErrOn", {
          text: "Please select a category!",
        });
      }
      console.log(this.search);
      try {
        const req = {
          Column: this.column,
          Search: this.search,
          Page_No: 0,
          Page_Size: 1000000,
        };
        const result = await this.$store.dispatch(
          "account/getCustomerListForAdd",
          req
        );
        console.log(result);
        this.searchCompanyList = result.getCustomers;
        // if (result === "no data") {
        //     this.isShow = false;
        // } else {
        //     this.isShow = true;
        // }
      } catch (err) {
        console.error(err);
      }
    },
    typeMoney: (money) => {
      if (typeof money !== "number" && money === "0.0") {
        return money;
      } else if (0 <= money && money < 1000) {
        money += "";
        const sep = money.split(".");

        if (sep[1] !== undefined && sep[1].length > 2) {
          sep[1] = sep[1].substring(0, 3);
          sep[1] /= 10;
          sep[1] = Math.round(sep[1]);
          return sep[0] + "." + sep[1];
        }

        return money;
      } else if (money < 0 || 1000 <= money) {
        let ifMinus = false;

        if (money < 0) {
          ifMinus = true;
          money = Math.abs(money);
        }

        money += "";
        const sep = money.split(".");
        let result = "";

        for (let i = 1; i <= sep[0].length; i++) {
          result = sep[0][sep[0].length - i] + result;
          if (i % 3 === 0 && i !== sep[0].length) {
            result = "," + result;
          }
        }

        if (sep[1] !== undefined) {
          if (sep[1].length > 2) {
            sep[1] = sep[1].substring(0, 3);
            sep[1] /= 10;
            sep[1] = Math.round(sep[1]);
          }
          result += "." + sep[1];
        }
        if (ifMinus) result = "-" + result;
        return result;
      }
    },
  },
};
</script>

<style scoped>
.total {
  font-weight: bold;
  font-size: 17px;
  display: flex;
  justify-content: flex-end;
  margin-top: 1%;
  margin-right: 4%;
}
.highlight {
  font-weight: 600;
  /* color: #ff0000; */
  background-color: #ffff00;
}
</style>
